var _defs, _path, _line, _animate, _animate2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWarning(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 142.5 143.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n            .triangle,.dot\r\n            {\r\n                fill:none;\r\n                stroke:#fbb040;\r\n                stroke-linecap:round;\r\n                stroke-linejoin:round;\r\n                stroke-dasharray: 1000;\r\n                stroke-dashoffset: 1000;\r\n            }\r\n            .triangle{\r\n                stroke-width:12px;\r\n            }\r\n            .dot{\r\n                stroke-width:15px;\r\n            }\r\n        "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "triangle",
    className: "triangle",
    d: "M115.62,37.33,164.34,145.6a10.9,10.9,0,0,1-10.05,15.12H45.6a10.9,10.9,0,0,1-10-15.2L88.23,32.64a6.12,6.12,0,0,1,5.54-3.52h0a6.11,6.11,0,0,1,6.11,6.1v69.16",
    transform: "translate(-28.69 -23.12)"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    id: "dot",
    className: "dot",
    x1: 71.31,
    y1: 103.39,
    x2: 71.31,
    y2: 102.83
  })), _animate || (_animate = /*#__PURE__*/React.createElement("animate", {
    xlinkHref: "#triangle",
    attributeName: "stroke-dashoffset",
    values: "1000; 871; 0; 0",
    keyTimes: "0;0.25; 0.75; 1",
    dur: "2s",
    fill: "freeze"
  })), _animate2 || (_animate2 = /*#__PURE__*/React.createElement("animate", {
    xlinkHref: "#dot",
    attributeName: "stroke-dashoffset",
    values: "1000; 1000; 0",
    keyTimes: "0;0.47; 1",
    dur: "2s",
    fill: "freeze"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.7e0d0a1c5dc3291129aa17121a340208.svg";
export { ForwardRef as ReactComponent };